// --------------------------------------------------------
// DETAILS ATTENDANCE RECORD ACCORDION - DetailsAttendanceRecordAccordion
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useState } from 'react'
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import useResponsiveInfo from '../../../../hooks/useResponsiveInfo';
import { ContentTopic, Name, Topic } from './DetailsAttendanceRecord.styled';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// DETAILS ATTENDANCE RECORD ACCORDION INTERFACE
// --------------------------------------------------------

interface IDetailsAttendanceRecordAccordion {
    children: any;
    name: string;
    isCollapsable: boolean;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const DetailsAttendanceRecordAccordion = ({ children, name, isCollapsable }: IDetailsAttendanceRecordAccordion) => {
    // --------------------------------------------------------
    // DETAILS ATTENDANCE RECORD ACCORDION PRIVATE DECLARATIONS
    // --------------------------------------------------------
    /*          <Topic>
                <Name>Evolução</Name>
              </Topic>*/

    // --------------------------------------------------------
    const [isOpen, setIsOpen] = useState(false)
    const { isMobile } = useResponsiveInfo();

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <div style={{ width: '100%' }}>
            <Topic style={{ justifyContent: 'space-between', cursor: isCollapsable ? 'pointer' : 'default' }} onClick={() => { isCollapsable && setIsOpen(prev => !prev) }}>
                <Name style={{ fontSize: isMobile ? '16px' : '' }}>{name}</Name>
                {isCollapsable && (<div style={{ marginRight: 10, marginTop: 12 }}>
                    {isOpen ? (
                        <MdKeyboardArrowUp size={30} />
                    ) : (
                        <MdKeyboardArrowDown size={30} />
                    )}
                </div>)}
            </Topic>
            {(!isCollapsable || isCollapsable && isOpen) && (<ContentTopic>
                {children}
            </ContentTopic>)}
        </div>
    )
    // --------------------------------------------------------
}

export default DetailsAttendanceRecordAccordion